import { render } from "./Users.vue?vue&type=template&id=0c49f481"
import script from "./Users.vue?vue&type=script&lang=ts"
export * from "./Users.vue?vue&type=script&lang=ts"
script.render = render

export default script